import './App.css';
import Player from './components/Player';

function App() {
  return (
    <> 
      <h1>Music Player</h1>
      <Player />
    </>
  );
}

export default App;
